export default class ProductSizeGuide extends Core.Component {
  onMount() {
    const drawerHeaderFragment = this.el.querySelector('[data-drawer-header-template]').content.cloneNode(true);
    const drawerFragment = this.el.querySelector('[data-drawer]').content.cloneNode(true);
    const embedModalBtnEl = this.el.querySelector('[data-drawer-btn]');
    const drawerModal = Core.Components.getComponent('drawer-modal');

    if (!drawerModal) return;

    this._drawerFlyout = drawerModal.createFlyout();
    this._drawerFlyout
      .then(drawerFlyout => {
        if (!drawerFlyout) return;

        this.events.register(embedModalBtnEl, 'click', e => {
          e.stopPropagation();
          e.preventDefault();

          drawerFlyout.populateHeading(drawerHeaderFragment);
          drawerFlyout.populateContent(drawerFragment);
          drawerModal.openFlyout(drawerFlyout, embedModalBtnEl);
          this.events.register(drawerFlyout.el, 'product-page-drawer:close', () => drawerModal.closeFlyout(drawerFlyout));
        });
      });
  }

  onDismount() {
    super.onDismount();

    if (this._drawerFlyout) {
      this._drawerFlyout.then(drawerFlyout => drawerFlyout.destroy());
    }
  }
}
